import { graphql } from "../graphql";
import mutation from "./mutation.gql";
import { FetchResult } from "@apollo/client";
import { graphqlExtractGraphqlErrors } from "@/v2/util/graphql-extract-graphql-errors";
import { IRepoErrors } from "../errors";
import { graphqlRemapValidationErrors } from "@/v2/util/graphql-remap-validation-errors";

export interface ICreateReactivationTestEmail {
  businessId: string;
  email: string;
  testSubject: boolean;
}

export async function createReactivationTestEmail(
  request: ICreateReactivationTestEmail
): Promise<Response> {
  let response: FetchResult<any, Record<string, any>, Record<string, any>>;
  const errors: IRepoErrors<ValidationErrors> = {};

  try {
    response = await graphql.mutate({
      mutation,
      variables: {
        businessId: request.businessId,
        toEmail: request.email,
        showTestOnSubject: request.testSubject,
      },
    });
  } catch (error) {
    errors.networkError = true;
    throw new CreateReactivationTestEmailError(errors);
  }

  if (response.errors) {
    errors.graphqlError = graphqlExtractGraphqlErrors(response);
    errors.validationError = graphqlRemapValidationErrors(response);

    throw new CreateReactivationTestEmailError(errors);
  }

  return response.data;
}

export class CreateReactivationTestEmailError extends Error {
  errors: IRepoErrors<ValidationErrors>;

  constructor(errors: IRepoErrors<ValidationErrors>) {
    super("Error in repo: createReactivationTestEmailError");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

type ValidationErrors = {};

interface Response {
  sendTestEmailForCampaign: boolean | null;
}
